
import { EvolucionInventarioProps } from '../../../containers/pages/Dashboard';
import {
  EVOLUCION_DASHBOARD_REQUEST,
  EVOLUCION_DASHBOARD_SUCCESS,
  EVOLUCION_DASHBOARD_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  evolucionInventario: EvolucionInventarioProps[];
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  evolucionInventario: [],
};

// Reducer con tipos definidos
const evolucionInventarioReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case EVOLUCION_DASHBOARD_REQUEST:
      return { ...state, loading: true };
    case EVOLUCION_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        evolucionInventario: action.payload,
      };
    case EVOLUCION_DASHBOARD_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default evolucionInventarioReducers;
